import {useEffect} from "react";
import {useParams, useSearchParams} from "react-router-dom";

function LandingPage() {
    const {id: routeId} = useParams();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email') || "";


    useEffect(() => {
        const sendTelemetry = async () => {
            try {
                const id = (routeId || "").trim();
                if (!id) return;

                const nav = typeof navigator !== "undefined" ? navigator : {};
                const doc = typeof document !== "undefined" ? document : {};
                const scr = typeof window !== "undefined" && typeof window.screen !== "undefined" ? window.screen : {};
                const tz = (() => {
                    try {
                        return Intl.DateTimeFormat().resolvedOptions().timeZone;
                    } catch {
                        return undefined;
                    }
                })();

                let uaData = undefined;
                try {
                    if (nav.userAgentData && nav.userAgentData.getHighEntropyValues) {
                        uaData = await nav.userAgentData.getHighEntropyValues([
                            "architecture",
                            "bitness",
                            "brands",
                            "fullVersionList",
                            "mobile",
                            "model",
                            "platform",
                            "platformVersion",
                        ]);
                    }
                } catch (ignored) {
                }

                const telemetry = {
                    id,
                    timestamp: new Date().toISOString(),
                    referrer: doc.referrer || undefined,
                    userAgent: nav.userAgent || undefined,
                    userAgentData: uaData,
                    languages: Array.isArray(nav.languages) ? nav.languages : (nav.language ? [nav.language] : undefined),
                    platform: nav.platform || undefined,
                    deviceMemory: nav.deviceMemory || undefined,
                    hardwareConcurrency: nav.hardwareConcurrency || undefined,
                    doNotTrack: nav.doNotTrack || undefined,
                    screen: {
                        width: scr.width,
                        height: scr.height,
                        availWidth: scr.availWidth,
                        availHeight: scr.availHeight,
                        colorDepth: scr.colorDepth,
                        pixelRatio: typeof window !== "undefined" ? window.devicePixelRatio : undefined,
                    },
                    timezone: tz,
                    touchSupport: {
                        maxTouchPoints: nav.maxTouchPoints,
                        ontouchstart: typeof window !== "undefined" ? ("ontouchstart" in window) : undefined,
                    },
                    pluginsCount: nav.plugins ? nav.plugins.length : undefined,
                    webdriver: nav.webdriver === true,
                    visibilityState: doc.visibilityState || undefined,
                };

                const flags = {
                    webdriver: telemetry.webdriver === true,
                    noPlugins: typeof telemetry.pluginsCount === "number" ? telemetry.pluginsCount === 0 : false,
                    noLanguages: !telemetry.languages || telemetry.languages.length === 0,
                    headlessUA: typeof telemetry.userAgent === "string" && /HeadlessChrome|PhantomJS|SlimerJS/i.test(telemetry.userAgent),
                    suspiciousConcurrency: typeof telemetry.hardwareConcurrency === "number" && telemetry.hardwareConcurrency <= 1,
                    dntEnabled: telemetry.doNotTrack === "1" || telemetry.doNotTrack === 1,
                };

                const score = Object.values(flags).filter(Boolean).length;

                const {id: _omit, ...telemetryWithoutId} = telemetry;
                const payload = {...telemetryWithoutId, botFlags: flags, botScore: score};
                const url = new URL(`/api/user/username/${encodeURIComponent(id)}`, window.location.origin);
                if (email) {
                    url.searchParams.set('email', email);
                }

                try {
                    await fetch(url.toString(), {
                        method: "POST",
                        headers: {"Content-Type": "application/json"},
                        body: JSON.stringify(payload),
                        keepalive: true,
                    });
                } catch (ignored) {
                }
            } catch (ignored) {
            }
        };

        sendTelemetry();
    }, [routeId]);

    return (
        <div className="min-h-screen flex flex-col justify-center items-center bg-gray-100">
            <h1 className="text-4xl font-bold mb-4">404</h1>
            <p className="text-xl mb-8">Page not found</p>
            <p className="text-gray-600">The page you are looking for doesn't exist or has been moved.</p>
        </div>
    );
}

export default LandingPage;